import React from "react";
import { Modal, Button } from "react-bootstrap";

const ModalConfirm = ({
    show,
    handleClose,
    title,
    description,
    descriptionDelete,
    onClick,
    onConfirm,
    confirmText = "Подтвердить",
    cancelText = "Вернуться обратно",
    confirmVariant = "primary",
    disabledConfirm = false,
}) => {
    const handleConfirm = onConfirm || onClick;

    const bodyText = description
        ? description
        : descriptionDelete
            ? "Если вы продолжите, вернуть действие будет невозможно."
            : "Если вы действительно хотите продолжить, подтвердите действие.";

    return (
        <Modal
            show={Boolean(show)}
            onHide={handleClose}
            centered
            scrollable
            backdrop="static"
            keyboard={false}
            dialogClassName="appModalDialog"
            contentClassName="appModalContent"
            backdropClassName="appModalBackdrop"
        >
            <Modal.Header closeButton>
                <Modal.Title>{title || "Подтвердите действие"}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {bodyText}
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="secondary"
                    className="btn-sm"
                    onClick={handleClose}
                    disabled={disabledConfirm}
                >
                    {cancelText}
                </Button>

                <Button
                    variant={confirmVariant}
                    className="btn-sm"
                    onClick={handleConfirm}
                    disabled={disabledConfirm || typeof handleConfirm !== "function"}
                >
                    {confirmText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalConfirm;
